import {
    getNowTime
} from '@/plugin/tools'
export default {
    watch: {
        lessonExam(val) {
            if (val && val.QuestionModel && val.QuestionModel.length > 0) {
                this.startExam()
            }
        },
        examId(val) {
            switch (val) {
                case -1: //結束 計分
                    this.lessonExam.ExamResult =
                        this.oNum + '/' + this.examTotal
                    this.saveExamRecord()
                    this.playSound('end')
                    break
                case 0: //重新開始
                    this.startTimer()
                    this.lessonExam.TakeDateTime = getNowTime()
                    this.playSound('qa')
                    break
                default:
                    //下一題
            }
        },
        //答題時觸發
        examTimeEndId(val) {
            if (val === -1) return //計分狀態不處理
            this.question.AnswerDateTime = getNowTime()
            if (this.examTotal === val) {
                //全部答完
                this.clearTimer()
                this.lessonExam.FinishDateTime = getNowTime()
            }
        }
    },
    methods: {
        startTimer() {
            this.clearTimer()
            if (this.examDuration) {
                this.timerId = setInterval(this.nextTimer, 1000)
            }
        },
        nextTimer() {
            this.timeing += 1
            if (this.timeing >= this.examDuration) {
                // if (this.timeing >= 5) {
                this.examTimeEndId = this.examTotal
                setTimeout(this.endExam, 0)
            }
        },
        clearTimer() {
            clearInterval(this.timerId)
            this.timeing = 0
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/examController.js